import { render, staticRenderFns } from "./webcam.vue?vue&type=template&id=dd0c3fd4&scoped=true&"
import script from "./webcam.vue?vue&type=script&lang=js&"
export * from "./webcam.vue?vue&type=script&lang=js&"
import style0 from "./webcam.vue?vue&type=style&index=0&id=dd0c3fd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0c3fd4",
  null
  
)

export default component.exports